import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppService } from '../../app.service';
import { SignupLoginDialog } from '../signupLogin/signup-login.component';

@Injectable({
	providedIn: 'root'
})
export class AnonymousUserService {
	constructor(
		private dialog: MatDialog,
		private appSrv: AppService
	) { }

	openSignupLogin(display: "signup"|"login", goPath: string, doRefresh: boolean, prefillUsername: string, callback: () => void) {
		goPath = (goPath ?? "").trim();
		prefillUsername = (prefillUsername ?? "").trim();

		let popup = this.dialog.open(
			SignupLoginDialog,
			{
				width: "100%",
				height:"100%",
				disableClose: true,
				autoFocus: true,
				panelClass: 'jmSignupLogin',
				data: {
					display: display,
					prefillUsername: prefillUsername,
					globalAccount: false
				}
			}
		);
		// close
		popup.afterClosed().subscribe(
			result => {
				if (callback != null) {
					callback();
				}
				else if (result !== 'cancel') {
					if (goPath !== '') {
						this.appSrv.goTo(goPath);
					}
					if (doRefresh) {
						location.reload();
					}
				}
			}
		);
		// dismiss
		popup.backdropClick().subscribe(
			redult => {
				// do nonting if dismiss
				if (callback != null) {
					callback();
				}
			}
		);
	}
}
